export default __webpack_public_path__ + "static/media/work-2.339df1ec.jpg";